/**
 * Dashboard Section Component
 *
 * Reusable section wrapper with consistent heading and description styling.
 * Reduces duplication of the section header pattern across the dashboard.
 */

import type { ReactNode } from 'react';

interface DashboardSectionProps {
  /** Unique ID for the section (used for aria-labelledby) */
  id: string;
  /** Section title */
  title: string;
  /** Section description */
  description: string;
  /** Section content */
  children: ReactNode;
}

export function DashboardSection({
  id,
  title,
  description,
  children,
}: DashboardSectionProps) {
  const headingId = `${id}-heading`;

  return (
    <section aria-labelledby={headingId} className="space-y-4">
      <div>
        <h2 id={headingId} className="text-lg font-semibold tracking-tight">
          {title}
        </h2>
        <p className="text-sm text-muted-foreground">{description}</p>
      </div>
      {children}
    </section>
  );
}
